import { simpleSet } from '@r/reducers/utils';

const setCalculationModeMarkupLabel = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.markup.label;

export const label = setCalculationModeMarkupLabel(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_MARKUP_LABEL',
  ''
);
